import { Flex, Text, Heading, Card, CardHeader, CardContent, Button, DataTable, LoadingOrbit } from '@chatsdet/ui';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ScheduleRun } from './types.js';
import { runColumns } from './columns.js';

type ScheduleRunHistoryProps = {
  runsQuery: UseQueryResult<{ runs: ScheduleRun[] }>;
  onClose: () => void;
};

export function ScheduleRunHistory({ runsQuery, onClose }: ScheduleRunHistoryProps) {
  return (
    <Card padding="lg">
      <CardHeader>
        <Flex align="center" justify="between">
          <div>
            <Heading level={3}>Run History</Heading>
            <Text size="sm" className="text-muted-foreground mt-1">
              Execution history for the selected schedule
            </Text>
          </div>
          <Button variant="outline" size="sm" onPress={onClose}>
            Close
          </Button>
        </Flex>
      </CardHeader>
      <CardContent>
        {runsQuery.isLoading ? (
          <Flex align="center" justify="center" className="py-8">
            <LoadingOrbit size="md" />
          </Flex>
        ) : runsQuery.isError ? (
          <Text className="text-destructive">Failed to load run history</Text>
        ) : runsQuery.data?.runs?.length ? (
          <DataTable columns={runColumns} data={runsQuery.data.runs} />
        ) : (
          <div className="text-center py-8">
            <Text className="text-muted-foreground">No runs recorded yet</Text>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
